import React from 'react';

const SavedSpecs = ({ specs, onUseSpec, onDeleteSpec }) => {
  if (specs.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-xl p-6">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">المواصفات المحفوظة</h3>
        <div className="text-center py-8">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
            </svg>
          </div>
          <p className="text-gray-600">لا توجد مواصفات محفوظة</p>
          <p className="text-gray-500 text-2xl mt-2">احفظ مواصفات سيارتك لتسريع البحث في المستقبل</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-xl p-6">
      <h3 className="text-2xl font-bold text-gray-800 mb-4">المواصفات المحفوظة</h3>
      <p className="text-gray-600 mb-6 text-2xl">مواصفات السيارات التي قمت بحفظها للبحث السريع.</p>
      
      <div className="space-y-4">
        {specs.map((spec) => (
          <div key={spec.id} className="border border-gray-200 rounded-xl p-4 hover:border-green-300 transition-colors">
            <div className="flex justify-between items-start mb-2">
              <div>
                <h4 className="font-semibold text-2xl  text-gray-800">{spec.brand} {spec.model}</h4>
                <div className="flex flex-wrap gap-1 mt-2">
                  {spec.group && <span className="bg-green-100 text-green-800 text-2xl px-2 py-1 rounded">{spec.group}</span>}
                  {spec.category && <span className="bg-green-100 text-green-800 text-2xl px-2 py-1 rounded">{spec.category}</span>}
                  <span className="bg-purple-100 text-purple-800 text-2xl px-2 py-1 rounded">{spec.year}</span>
                </div>
              </div>
              <button 
                className="text-red-500 hover:text-red-700"
                onClick={() => onDeleteSpec(spec.id)}
              >
                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
            <div className="text-2xl text-gray-500 mb-3">تم الحفظ في: {spec.date}</div>
            <button
              className="w-full bg-gradient-to-r from-blue-900 to-indigo-900 text-white py-2 rounded-lg text-2xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-300"
              onClick={() => onUseSpec(spec)}
            >
              البحث باستخدام هذه المواصفات
            </button>
          </div>
        ))}
      </div>
      
      <div className="mt-6 pt-4 border-t border-gray-100 text-center">
        <p className="text-gray-500 text-2xl">يتم حفظ المواصفات تلقائياً في ذاكرة المتصفح</p>
      </div>
    </div>
  );
};

export default SavedSpecs;